import type { FC } from "react";
import { toast } from "sonner";
import { usePinPropertyRelatedMutation } from "web_myplann/Api/Portfolio/Mutations/usePinPropertyRelatedMutation";
import { useUnpinPropertyRelatedMutation } from "web_myplann/Api/Portfolio/Mutations/useUnpinPropertyRelatedMutation";
import { usePropertyRelatedOptionsQuery } from "web_myplann/Api/Portfolio/Queries/usePropertyRelatedOptionsQuery";
import type { ClientPortfolioDetailRelatedResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { RelatedPinKind } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/pinKind";
import { RelatedPinDrawerContent } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/RelatedPinDrawerContent";

type Props = {
	kind: RelatedPinKind;
	open: boolean;
	onClose: () => void;
	related: ClientPortfolioDetailRelatedResponseDTO[];
	propertyId: number;
};

export const PropertyRelatedPinDrawer: FC<Props> = ({
	kind,
	open,
	onClose,
	related,
	propertyId,
}) => {
	const { t } = useResource();

	const { data: options, isLoading } = usePropertyRelatedOptionsQuery(
		propertyId,
		open,
	);
	const { mutate: pinRelated, isPending: isPinning } =
		usePinPropertyRelatedMutation(propertyId);
	const { mutate: unpinRelated, isPending: isUnpinning } =
		useUnpinPropertyRelatedMutation(propertyId);

	return (
		<RelatedPinDrawerContent
			kind={kind}
			open={open}
			onClose={onClose}
			related={related}
			options={options}
			isLoading={open && isLoading}
			isPending={isPinning || isUnpinning}
			onPin={(request) =>
				pinRelated(request, {
					onSuccess: () => {
						toast.success(t(Resources.DataCard.relatedPinToast));
						onClose();
					},
				})
			}
			onUnpin={(relatedId) =>
				unpinRelated(relatedId, {
					onSuccess: () =>
						toast.success(t(Resources.DataCard.relatedUnpinToast)),
				})
			}
		/>
	);
};
